<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<p style="padding-top:120px;"></p>
<p style="text-indent:0px">There are many people in this world, including the indigenous tribes, who care for passionately, and act as good custodians in the caring for our planet, the various species of wildlife and their varied habitats.</p>
<p>Their belief is to live in harmony with nature and to use precious resources wisely, but to also return what they already have taken out in a managed way, without any detrimental effect to the environment and those around.</p>
<p>But, unfortunately, we also have people who are only interested in greed and profit and care nothing for the overall impact this has on wildlife, their habitats and their overall population, when extracting any form of natural resources for their own gains.</p>
<p>How can you look a child in the eye and say that there were once tigers and dolphins, great apes, birds of paradise, elephants, snow leopards (to name but a few); there were rainforests, moorlands, grass plains, so many creatures and plants, life that lived in the seas and rivers; there were polar caps, and there were indigenous tribes that once lived in those forests?</p>
<p>But there is hope that we may be able to turn the planet around for the benefit of all—our fellow creatures, plant life, shared habitats—and still be good custodians.</p>
<p>This story tells of a race of people, whose aim is to replenish the world with their stewardship and custodianship. They will be the guardians of life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?1ba1cd3c